import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { Timezone } from '@teammood/shared/util/locale';
import { TeamMemberForAccount } from "../account/account.type";
import { AccountService } from "../account/account.service";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { TranslateService } from "@ngx-translate/core";
import { FormControl, FormGroup } from "@angular/forms";
import { debounceTime, distinctUntilChanged, Subject, takeUntil, tap } from "rxjs";
import { NotificationTimeString } from "@teammood/shared/util/core";

@Component({
    selector: "notification-time",
    templateUrl: "./notification-time.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationTimeSettingsComponent implements OnInit, OnDestroy {

    timezones: Timezone[];
    teamMember: TeamMemberForAccount;

    notificationTime= new FormGroup({
        timeZone: new FormControl(''),
        time: new FormControl(''),
    })

    private _destroy$ = new Subject<void>();

    constructor(
        private translate: TranslateService,
        private snackBarService: SnackBarService,
        private accountService: AccountService,
        private logger: LoggerService
    ){}

    ngOnInit(){

        this.accountService.get().then((teamMember) => {
            this.teamMember = teamMember;
            this.notificationTime.setValue(teamMember.notificationTime, {emitEvent: false});
        });

        this.notificationTime.valueChanges.pipe(

            debounceTime(500),
            distinctUntilChanged(),
            tap((notificationTime: NotificationTimeString) => { // array of workingDays
                this.teamMember = {
                    ...this.teamMember,
                    notificationTime: notificationTime
                }
                this.saveChanges();
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    saveChanges() {
        try {
            this.accountService.update(this.teamMember).then(() => {
                this.snackBarService.success(this.translate.instant('saved'));
            })
        } catch(e){
            this.logger.error(e)
            this.snackBarService.error(this.translate.instant('error'));
        }
    }
}